import { render, staticRenderFns } from "./AdminOrders.vue?vue&type=template&id=40a1fcb0&scoped=true"
import script from "./AdminOrders.vue?vue&type=script&lang=js"
export * from "./AdminOrders.vue?vue&type=script&lang=js"
import style0 from "./AdminOrders.vue?vue&type=style&index=0&id=40a1fcb0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a1fcb0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40a1fcb0')) {
      api.createRecord('40a1fcb0', component.options)
    } else {
      api.reload('40a1fcb0', component.options)
    }
    module.hot.accept("./AdminOrders.vue?vue&type=template&id=40a1fcb0&scoped=true", function () {
      api.rerender('40a1fcb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/views/AdminOrders.vue"
export default component.exports